// import React, { useEffect, useRef } from "react";
// import * as d3 from "d3";
// import { useSelector } from "react-redux";

// const DonorPieChart = () => {
//   const donors = useSelector((state) => state.donor?.donors || []);
//   const chartRef = useRef();

//   useEffect(() => {
//     if (!donors.length) return;

//     // Group by salutation
//     const count = d3.rollup(
//       donors,
//       (v) => v.length,
//       (d) => d.salutation || "Unknown"
//     );

//     const data = Array.from(count, ([label, value]) => ({ label, value }));

//     // Clear old chart
//     d3.select(chartRef.current).selectAll("*").remove();

//     const width = 260;
//     const height = 260;
//     const radius = Math.min(width, height) / 2;

//     const svg = d3
//       .select(chartRef.current)
//       .append("svg")
//       .attr("viewBox", `0 0 ${width} ${height + 100}`) // extra for legend
//       .style("width", "100%")
//       .style("height", "auto")
//       .append("g")
//       .attr("transform", `translate(${width / 2}, ${height / 2})`);

//     const pie = d3.pie().value((d) => d.value);
//     const arc = d3.arc().innerRadius(0).outerRadius(radius);
//     const color = d3.scaleOrdinal(d3.schemeSet2);

//     const arcs = svg.selectAll("arc").data(pie(data)).enter();

//     // Pie slices
//     arcs
//       .append("path")
//       .attr("d", arc)
//       .attr("fill", (d) => color(d.data.label))
//       .style("stroke", "#fff")
//       .style("stroke-width", "2px");

//     // Slice labels
//     arcs
//       .append("text")
//       .attr("transform", (d) => `translate(${arc.centroid(d)})`)
//       .style("text-anchor", "middle")
//       .style("font-size", "12px")
//       .text((d) => d.data.label);

//     // --- Legend with wrap ---
//     const legendGroup = svg
//       .append("g")
//       .attr("transform", `translate(${-width / 2 + 10}, ${radius + 20})`);

//     const legendMaxWidth = width - 20;
//     let xOffset = 0;
//     let yOffset = 0;
//     const xSpacing = 80;
//     const ySpacing = 20;

//     data.forEach((d) => {
//       if (xOffset + xSpacing > legendMaxWidth) {
//         xOffset = 0;
//         yOffset += ySpacing;
//       }

//       const legendItem = legendGroup.append("g").attr("transform", `translate(${xOffset}, ${yOffset})`);

//       legendItem
//         .append("circle")
//         .attr("r", 6)
//         .attr("fill", color(d.label));

//       legendItem
//         .append("text")
//         .attr("x", 12)
//         .attr("y", 4)
//         .style("font-size", "13px")
//         .style("font-weight", "500")
//         .text(`${d.label} (${d.value})`);

//       xOffset += xSpacing;
//     });
//   }, [donors]);

//   return <div ref={chartRef} style={{ width: "100%", maxWidth: "300px", margin: "0 auto" }}></div>;
// };

// export default DonorPieChart;
import React, { useEffect, useRef } from "react";
import * as d3 from "d3";
import { useSelector } from "react-redux";

const DonorPieChart = () => {
  const donors = useSelector((state) => state.donor?.donors || []);
  const chartRef = useRef();

  useEffect(() => {
    if (!donors.length) return;

    // ---------------------
    // ⭐ GLOBAL TOOLTIP
    // ---------------------
    const tooltipId = "global-d3-tooltip";
    let tooltip = d3.select(`#${tooltipId}`);

    if (tooltip.empty()) {
      tooltip = d3
        .select("body")
        .append("div")
        .attr("id", tooltipId)
        .attr("class", "d3-tooltip");
    }

    // ---------------------
    // Group by salutation
    // ---------------------
    const count = d3.rollup(
      donors,
      (v) => v.length,
      (d) => d.salutation || "Unknown"
    );
    const data = Array.from(count, ([label, value]) => ({ label, value }));

    // Clear previous chart
    d3.select(chartRef.current).selectAll("*").remove();

    const width = 260;
    const height = 260;
    const radius = Math.min(width, height) / 2;
    const viewPadding = 30;

    const container = d3.select(chartRef.current);

    // ---------------------
    // SVG
    // ---------------------
    const svg = container
      .append("svg")
      .attr(
        "viewBox",
        `0 0 ${width + viewPadding} ${height + 100 + viewPadding}`
      )
      .style("width", "100%")
      .style("height", "auto");

    const g = svg
      .append("g")
      .attr(
        "transform",
        `translate(${(width + viewPadding) / 2}, ${(height + viewPadding) / 2})`
      );

    const pie = d3.pie().sort(null).value((d) => d.value);
    const arc = d3.arc().innerRadius(0).outerRadius(radius);
    const arcHover = d3.arc().innerRadius(0).outerRadius(radius + 5);
    const color = d3.scaleOrdinal(d3.schemeSet2);

    // ---------------------
    // Pie slices
    // ---------------------
    const slices = g
      .selectAll("slice")
      .data(pie(data))
      .enter()
      .append("path")
      .attr("fill", (d) => color(d.data.label))
      .style("stroke", "#fff")
      .style("stroke-width", "2px");

    slices
      .transition()
      .duration(800)
      .attrTween("d", function (d) {
        const i = d3.interpolate({ startAngle: 0, endAngle: 0 }, d);
        return (t) => arc(i(t));
      });

    // ---------------------
    // Slice hover (GLOBAL TOOLTIP)
    // ---------------------
    slices
      .on("mouseenter", function (event, d) {
        d3.select(this)
          .transition()
          .duration(200)
          .attr("d", arcHover);

        tooltip
          .style("display", "block")
          .html(`<b>${d.data.label}</b><br/>Count: ${d.data.value}`)
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY - 40 + "px");
      })
      .on("mousemove", function (event) {
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY - 40 + "px");
      })
      .on("mouseleave", function () {
        d3.select(this)
          .transition()
          .duration(200)
          .attr("d", arc);

        tooltip.style("display", "none");
      });

    // ---------------------
    // Legend
    // ---------------------
    const legendGroup = svg
      .append("g")
      .attr("transform", `translate(0, ${height + 50})`);

    const xSpacing = 90;
    const ySpacing = 20;
    const itemsPerRow = Math.floor(width / xSpacing) || 1;
    let yOffset = 0;

    const rows = [];
    for (let i = 0; i < data.length; i += itemsPerRow) {
      rows.push(data.slice(i, i + itemsPerRow));
    }

    rows.forEach((row) => {
      const rowWidth = row.length * xSpacing;
      let rowXOffset = (width - rowWidth + xSpacing) / 2;

      row.forEach((d) => {
        const lg = legendGroup
          .append("g")
          .attr("class", "legend-item")
          .attr("transform", `translate(${rowXOffset}, ${yOffset})`)
          .style("cursor", "pointer");

        lg.append("circle").attr("r", 6).attr("fill", color(d.label));

        lg
          .append("text")
          .attr("x", 12)
          .attr("y", 4)
          .style("font-size", "13px")
          .style("font-weight", "500")
          .text(d.label);

        // ---------------------
        // ⭐ Legend hover → SAME slice position tooltip
        // ---------------------
        lg.on("mouseenter", () => {
          slices
            .transition()
            .duration(200)
            .style("opacity", (s) =>
              s.data.label === d.label ? 1 : 0.3
            );

          slices
            .filter((s) => s.data.label === d.label)
            .transition()
            .duration(200)
            .attr("d", arcHover);

          const sliceData = slices
            .data()
            .find((s) => s.data.label === d.label);

          const [cx, cy] = arc.centroid(sliceData);
          const svgRect = svg.node().getBoundingClientRect();

          tooltip
            .style("display", "block")
            .html(
              `<b>${sliceData.data.label}</b><br/>Count: ${sliceData.data.value}`
            )
            .style("left", svgRect.left + cx + width / 2 + "px")
            .style("top", svgRect.top + cy + height / 2 - 40 + "px");
        });

        lg.on("mouseleave", () => {
          slices
            .transition()
            .duration(200)
            .style("opacity", 1)
            .attr("d", arc);

          tooltip.style("display", "none");
        });

        rowXOffset += xSpacing;
      });

      yOffset += ySpacing;
    });
  }, [donors]);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        maxWidth: "300px",
        margin: "0 auto",
        position: "relative",
      }}
    />
  );
};

export default DonorPieChart;